import React, { useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles, {
  ContainerPrincipal,
  TitleTable,
} from './ValoresAPagarPelaABEStyles';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm';
import { ButtonUI } from '../../../components';
import CheckboxField from '../../../components/UI/Field/Checkbox/CheckboxField';
import Dica from '../../../components/UI/Dica/Dica';
import SearchButtonWithLabel from '../../../components/UI/Button/Search/Label/SearchButtonWithLabel';
import { ClearButton } from '../../../components/AtualizarMuralDashboard/atualizarMuralDashboard.styles';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import DateField from '../../../components/UI/Field/Date/DateField';
import { downloadFileSispag, openPageFileBase64, toBrazilianDate } from '../../../helpers';
import { findValoresAPagarPelaAbe, imprimirValoresAPagarPelaAbeExcel, imprimirValoresAPagarPelaAbePdf } from '../../../services/core/analiseGerencial/analiseGerencial.service';
import TabelaValoresAPagarPelaABE from './TabelaValoresAPagarPelaABE';

function ValoresAPagarPelaABEComponent() {
  const styles = useStyles();

  const [contabilizarClienteInativo, setContabilizarClienteInativo] = useState(false);
  const [exibirTotalizacaoPorCliente, setExibirTotalizacaoPorCliente] = useState(false);
  const [exibirApenasClienteComPrestacaoDeContasParaODia, setExibirApenasClienteComPrestacaoDeContasParaODia] = useState(false);
  const [dataReferencia, setDataReferencia] = useState(toBrazilianDate(new Date()));
  const [selecionarDosDoisSistemas, setSelecionarDosDoisSistemas] = useState(true);
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(false);

  const onSubmitHandler = useCallback(() => {
    setLoading(true);
    setContent([]);

    findValoresAPagarPelaAbe(
      contabilizarClienteInativo,
      exibirTotalizacaoPorCliente,
      exibirApenasClienteComPrestacaoDeContasParaODia,
      dataReferencia,
      selecionarDosDoisSistemas,
    )
      .then((response) => {
        setContent(response.data);
        if (response.data.length === 0) {
          toast.error('Nenhum resultado foi encontrado relacionado à sua pesquisa');
        } else {
          toast.success('Pesquisa realizada com sucesso!');
        }
      }).finally(() => {
        setLoading(false);
      });
  }, [contabilizarClienteInativo, exibirTotalizacaoPorCliente, exibirApenasClienteComPrestacaoDeContasParaODia, dataReferencia, selecionarDosDoisSistemas]);

  const onLimparHandler = useCallback(() => {
    setContabilizarClienteInativo(false);
    setExibirTotalizacaoPorCliente(false);
    setExibirApenasClienteComPrestacaoDeContasParaODia(false);
    setDataReferencia(toBrazilianDate(new Date()));
    setSelecionarDosDoisSistemas(true);
    setContent([]);
  }, []);

  const onClickExportarExcel = useCallback(() => {
    setLoading(true);
    imprimirValoresAPagarPelaAbeExcel(
      contabilizarClienteInativo,
      exibirTotalizacaoPorCliente,
      exibirApenasClienteComPrestacaoDeContasParaODia,
      dataReferencia,
      selecionarDosDoisSistemas,
    ).then((response) => {
      if (response.data.length > 0) {
        downloadFileSispag(response.headers.filename, response.data);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o Excel. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [contabilizarClienteInativo, exibirTotalizacaoPorCliente, exibirApenasClienteComPrestacaoDeContasParaODia, dataReferencia, selecionarDosDoisSistemas]);

  const onClickExportarPDF = useCallback(() => {
    setLoading(true);
    imprimirValoresAPagarPelaAbePdf(
      contabilizarClienteInativo,
      exibirTotalizacaoPorCliente,
      exibirApenasClienteComPrestacaoDeContasParaODia,
      dataReferencia,
      selecionarDosDoisSistemas,
    ).then((response) => {
      if (response.data.length > 0) {
        openPageFileBase64(response.data, response.headers['content-type']);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o PDF. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [contabilizarClienteInativo, exibirTotalizacaoPorCliente, exibirApenasClienteComPrestacaoDeContasParaODia, dataReferencia, selecionarDosDoisSistemas]);

  return (
    <ContainerPrincipal>
      <LoadingUI show={loading} />

      <div style={{ border: '1px solid', padding: '10px', width: '90%' }}>
        <WrapperSubTitleForm title="Opções de consulta">
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <CheckboxField
                label="Contabilizar Cliente Inativos"
                name="contabilizarClienteInativo"
                checked={contabilizarClienteInativo}
                onChange={e => setContabilizarClienteInativo(e.target.checked)}
              />
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <CheckboxField
                label="Exibir Totalização por Cliente"
                name="exibirTotalizacaoPorCliente"
                checked={exibirTotalizacaoPorCliente}
                onChange={e => setExibirTotalizacaoPorCliente(e.target.checked)}
              />
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <div>
                <CheckboxField
                  label="Exibir apenas Cliente com Prestação de Contas para o dia"
                  name="exibirApenasClienteComPrestacaoDeContasParaODia"
                  checked={exibirApenasClienteComPrestacaoDeContasParaODia}
                  onChange={e => setExibirApenasClienteComPrestacaoDeContasParaODia(e.target.checked)}
                />
              </div>
              <div style={{ margin: '5px' }}>
                <DateField
                  isForm
                  name="Data de Referência"
                  disabled={!exibirApenasClienteComPrestacaoDeContasParaODia}
                  value={dataReferencia}
                  onChange={e => setDataReferencia(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <div>
                <CheckboxField
                  label="Selecionar dados dos dois sistemas"
                  name="selecionarDosDoisSistemas"
                  checked={selecionarDosDoisSistemas}
                  onChange={e => setSelecionarDosDoisSistemas(e.target.checked)}
                />
              </div>
              <div>
                <Dica mensagemDica="Utilizar dados do sistema ABE e do sistema ABE Web para geração do relatório." />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <div>
              <ClearButton
                style={{ width: '150px' }}
                onClick={() => { onLimparHandler(); }}
                iconFontAwesome="fas fa-eraser"
                label="Limpar"
              />
              <SearchButtonWithLabel
                style={{ width: '150px', marginLeft: '10px' }}
                label="Pesquisar"
                type="button"
                onClick={() => { onSubmitHandler(); }}
              />
            </div>
          </div>
        </WrapperSubTitleForm>
      </div>
      <div style={{
        border: '1px solid', padding: '10px', width: '100%', marginTop: '10px',
      }}
      >
        <WrapperSubTitleForm title="Exportar">
          <div style={{ marginTop: '10px' }}>
            <ButtonUI
              style={{ width: '100px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarExcel(); }}
            >
              Excel
            </ButtonUI>
            <ButtonUI
              style={{ width: '100px', marginLeft: '10px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarPDF(); }}
            >
              PDF
            </ButtonUI>
          </div>
          <TitleTable>
            Relação de Clientes
          </TitleTable>
          <TabelaValoresAPagarPelaABE
            content={content}
          />
        </WrapperSubTitleForm>
      </div>
    </ContainerPrincipal>
  );
}

export const ValoresAPagarPelaABE = withRouter(ValoresAPagarPelaABEComponent);
